export default __webpack_public_path__ + "static/media/in-progress-active.4c1b6562.svg";